const readMagicBytes = (file, length) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = e => resolve(new Uint8Array(e.target.result));
    reader.onerror = reject;
    reader.readAsArrayBuffer(file.slice(0, length));
  });

const matchBytes = (bytes, signature, offset = 0) => signature.every((byte, i) => bytes[offset + i] === byte);

const TGA_VALID_IMAGE_TYPES = new Set([0, 1, 2, 3, 9, 10, 11]);

export const isValidImageContent = async file => {
  const ext = file.name.split('.').pop().toLowerCase();
  try {
    const bytes = await readMagicBytes(file, 12);
    switch (ext) {
      case 'jpg':
      case 'jpeg':
        return matchBytes(bytes, [0xff, 0xd8, 0xff]);
      case 'png':
        return matchBytes(bytes, [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]);
      case 'gif':
        return matchBytes(bytes, [0x47, 0x49, 0x46, 0x38]);
      case 'bmp':
        return matchBytes(bytes, [0x42, 0x4d]);
      case 'webp':
        return matchBytes(bytes, [0x52, 0x49, 0x46, 0x46]) && matchBytes(bytes, [0x57, 0x45, 0x42, 0x50], 8);
      case 'tiff':
      case 'tif':
        return matchBytes(bytes, [0x49, 0x49, 0x2a, 0x00]) || matchBytes(bytes, [0x4d, 0x4d, 0x00, 0x2a]);
      case 'qoi':
        return matchBytes(bytes, [0x71, 0x6f, 0x69, 0x66]);
      case 'pbm':
        return bytes[0] === 0x50 && bytes[1] >= 0x31 && bytes[1] <= 0x37;
      case 'tga':
        // TGA não tem magic bytes — valida pelo byte de tipo de imagem (offset 2)
        return bytes[1] <= 1 && TGA_VALID_IMAGE_TYPES.has(bytes[2]);
      case 'heic':
      case 'heif':
        // ISO Base Media File Format: 'ftyp' em offset 4, major brand 'heic' em offset 8
        return matchBytes(bytes, [0x66, 0x74, 0x79, 0x70], 4) && matchBytes(bytes, [0x68, 0x65, 0x69, 0x63], 8);
      default:
        return false;
    }
  } catch {
    return false;
  }
};
